var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_8080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.66669 3.66667L10.6667 4.66667M7.66669 5.66667L8.66669 6.66667M5.66669 7.66667L6.66669 8.66667M3.66669 9.66667L4.66669 10.6667M1.71046 11.7105L4.28954 14.2896C4.42155 14.4216 4.48755 14.4876 4.56366 14.5123C4.63061 14.5341 4.70273 14.5341 4.76967 14.5123C4.84578 14.4876 4.91179 14.4216 5.04379 14.2896L14.2895 5.04382C14.4215 4.91182 14.4876 4.84581 14.5123 4.7697C14.534 4.70276 14.534 4.63064 14.5123 4.56369C14.4876 4.48758 14.4216 4.42158 14.2895 4.28957L11.7105 1.71049C11.5785 1.57848 11.5124 1.51248 11.4363 1.48775C11.3694 1.466 11.2973 1.466 11.2303 1.48775C11.1542 1.51248 11.0882 1.57848 10.9562 1.71049L1.71046 10.9562C1.57845 11.0882 1.51245 11.1542 1.48772 11.2304C1.46597 11.2973 1.46597 11.3694 1.48772 11.4364C1.51245 11.5125 1.57845 11.5785 1.71046 11.7105Z",
    stroke: "#088AB2",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_8080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare);
export default __webpack_public_path__ + "static/media/square.36b68d7bb890af34f5b0d5506f882922.svg";
export { ForwardRef as ReactComponent };